import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import { IThankYouPage } from 'interfaces/IThankYouPage';
import { SvgIcon } from 'components/SvgIcon';
import BoletoCod from '../BoletoCod/index';
import Grid from '@material-ui/core/Grid';
import Translate from 'components/Translate';
import ModalDoubts from '../../ModalDoubts';
import BoletoDownload from '../BoletoDownload';
import { getCdnImage } from 'functions';

const style = require('./boletoProducer.css');

interface IProps {
  infos: IThankYouPage;
}

export default class BoletoProducer extends BaseComponent<any, IProps> {

  render() {

    if (!this.props) {
      return <div />;
    }

    return (
      <div className={style.component}>
        <div className='chk-boletoProducer__header'>
          <Grid
            container
            spacing={16}
            alignItems={'center'}
            justify={'flex-start'}
            direction={'row'}
          >
            <Grid item className='chk-grid' xs={12} sm={1}>
              <img
                className='chk-image'
                src={getCdnImage(this.props.infos.imgProduct)}
              />
            </Grid>
            <Grid item className='chk-grid' xs={12} sm={4} md={4} lg={4}>
              <div className={'chk-label theme-label'} id='thankyou-title'>
                <span>
                  <SvgIcon name='check' />
                </span>
                &nbsp; {this.props.infos.isFree ?
                  <Translate term='Sucesso! Verifiquer seu e-mail!' />
                  : <Translate term='Obrigado pela Compra!' />
                }
              </div>
              <div className={'chk-paragraph theme-label'} id='thankyou-text'>
                <Translate term={'Enviamos instruções para acessar seu Conteúdo no email '} />
                <span className='chk-email'>{this.props.infos.userEmail || 'utilizado na compra'}</span>
                <Translate term={'. Se não encontrar nos próximos minutos, verifique também sua caixa de Lixo Eletrônico.'} />
              </div>
              <div className='doubts'>
                <div className='click-here'>
                  <Translate term={'Caso ainda tenha alguma dúvida '} /> &nbsp;
                  <ModalDoubts name={` clique aqui`} infos={this.props.infos} showProducerContact />
                </div>
              </div>
            </Grid>
            <Grid item className='chk-grid' xs={12} sm={4} md={5} lg={5}>
              <div className='chk-boleto-cod'>
                <BoletoCod isButton={true} isProducerThp={true} cod={this.props.infos.bankslipCode} />
              </div>
            </Grid>
            <Grid item className='chk-grid' xs={12} sm={3} md={2} lg={2}>
              <BoletoDownload nameButton={'Baixar'} bankslipUrl={this.props.infos.bankslipUrl} />
            </Grid>
          </Grid>
        </div>
        {
          this.props.infos.producerIframe && this.props.infos.displayThankyou ?
            <iframe
              src={this.props.infos.producerIframe}
              name='iframe-producer'
              className='chk-boletoProducer__thankouPageiFrame'
            /> : null
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ThankYouPage/BoletoPage/BoletoProducer/index.tsx